import styled from 'styled-components';

// Design tokens from ticket mockup "full-width-strip-dense.html" (Tailwind red scale).
export const BannerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 20px;
  background: #fef2f2;
  border-bottom: 1px solid #fecaca;
  color: #7a271a;
  font-size: 13px;
  cursor: pointer;
`;

export const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: #dc2626;
  color: #fff;
  font-weight: 700;
  font-size: 12px;
  line-height: 1;
`;

export const Headline = styled.span`
  font-weight: 600;
  color: #7a271a;
`;

export const Divider = styled.span`
  width: 1px;
  height: 14px;
  background: #fecaca;
  margin: 0 2px;
`;

export const Categories = styled.span`
  display: flex;
  gap: 12px;
  color: #991b1b;
  font-weight: 600;
`;

export const ReviewAll = styled.span`
  margin-left: auto;
  color: #b91c1c;
  font-weight: 600;
  white-space: nowrap;
`;
